import script from "./baseProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./baseProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./baseProgressBar.vue?vue&type=style&index=0&id=ba656bfa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba656bfa"]])

export default __exports__